import React from "react";
import  "./Terms.css";
function Terms() {
    return(
        <main style={{marginTop:"100px"}}>
        <div className="container" style={{borderRadius:"20px"}}>
            <h2 className="Title_Addjops">سياسة الأستخدام</h2>
            <div className="Terms_content">
                <h3>مرحبا بك فى موقع صنايعية في خدمتك :</h3>
                <p> نشكرك على استخدام خدمتنا والتى يشار اليها باسم خدمتنا فانك توافق على هذه البنود الرجاء القراءة بعناية </p>
                <hr className="line"/>
                <h3>ضمان استلام الخدمة :</h3>
                <p>نلتزم في موقعنا بحماية حقوقك ونضمن توصيل الخدمة التي اشتريتها طالما أن الاتفاق مع الصنايعى حصل داخل الموقع ولم يخالف أياً من شروط الاستخدام </p>
                <hr className="line"/>

                <h3>طلب الوثائق الشخصية لإثبات الهوية :</h3>
                <p>نطلب من المستخدم في بعض الأحيان توثيق حسابه بالهوية الشخصية. هذا الإجراء روتيني وقد نطلبه من جميع المستخدمين في الموقع لتحقيق بيئة عمل آمنة</p>
                <hr className="line"/>
                
                <h3>استعادة المبلغ المدفوع :</h3>
                <p>بعد إلغاء الطلب وفي حال عدم الرغبة بشراء أي خدمات أخرى، يمكنك استرداد المبلغ الذي دفعته إلى حسابك في البطاقة الائتمانية عبر فتح محادثة مع ادارة الموقع تخضع عملية الاعادة لعدة شروط</p>
                <ol>
                    <li>تكون الأرصدة متاحة للإعادة خلال 30 يوماً من تاريخ الشحن بحد أقصى في حال كانت وسيلة الشحن توفر خياراً للإعادة</li>
                </ol>
                <hr className="line"/>
                
                <h3>أسباب إيقاف الحساب :</h3>
                <p>يحتفظ الموقع بالحق في إيقاف الحساب بشكل مؤقت أو دائم في حال استخدامه بطرق غير قانونية. من الأمثلة على هذه الاستخدامات:</p>
                <ol>
                    <li>استخدام وسيلة دفع مسروقة أو غير مملوكة للمستخدم</li>
                    <li>عرض دفع ثمن الخدمة خارج الموقع </li>
                    <li>طلب تنفيذ خدمات مخالفة لشروط الاستخدام</li>
                   
                    <li>انتحال الشخصية أو تسجيل الشاب باسم فتاة أو العكس، كذلك رفع صورة شخصية ليست لصاحب الحساب نفسه أو استخدام أسماء أو صور شخصيات عامة، أو استخدام معلومات غير صحيحة عند التسجيل كرقم الهاتف، الإيميل، عنوان الموقع، الأسماء ذات معنى مؤذٍ أو مخل</li>
                
                    <li>محاولة الإضرار بالموقع أو مستخدميه</li>
                    <li>نشر أي محتوى يخالف القوانين المنظمة. على سبيل المثال لا الحصر: الخداع والتزوير والاحتيال، التهديد أو الإزعاج لأي شخص أو شركة أو جماعة، نشر المواد الإباحية والجنسية، نشر الفيروسات أو ملفات تجسس، إضافة روابط لمواقع تحتوي على مثل هذه المخالفات</li>


                </ol>
            </div>
        </div>
    </main>
    )
}
export default Terms;